module.exports = __webpack_public_path__ + "static/media/Մարիետա-Բադալյան-Ինձ-նման-թախծոտ.d3345ab6.mp3";